<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">Estado cartera</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <div class="p-2">
            <mat-label class="lblblack">{{this.form.get('nroDocumento').value}}</mat-label>
        </div>
        <div class="p-2">
            <mat-label class="lblblack2">{{this.form.get('nombresApellidos').value}}</mat-label>
        </div>
        <div class="p-2">
            <mat-label class="lblblack">Fecha afiliación</mat-label>
            <mat-label class="lblblack2 lblmargen">{{this.form.get('fechaAfiliacion').value | fechapipe}}</mat-label>
        </div>
        <div class="p-2">
            <mat-label class="lblblack">Producto</mat-label>
            <mat-label class="lblblack2 lblmargen">{{this.form.get('producto').value}}</mat-label>
        </div>
        <div class="p-2" *ngIf="MostrarEdad()">
            <mat-label class="lblblack" *ngIf="MostrarEdad()">Edad</mat-label>
            <mat-label class="lblblack2 lblmargen" *ngIf="MostrarEdad()">{{this.form.get('edad').value}}</mat-label>
        </div>
        <div class="p-2">
            <mat-label class="lblblack">Estado</mat-label>
            <mat-label class="lblblack lblmargen" [class]="this.form.get('estadoColor').value">{{this.form.get('estado').value}}</mat-label>
        </div>
        <div class="p-2" *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.form.get('estadoDescripcion').value)">
            <mat-label class="lblblack" *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.form.get('estadoDescripcion').value)">Tipo</mat-label>
            <mat-label class="lblblack lblmargen" [class]="this.form.get('estadoDescripcionColor').value" *ngIf="this.utilitariosService.VerificarContieneDatosTexto(this.form.get('estadoDescripcion').value)">{{this.form.get('estadoDescripcion').value}}</mat-label>
        </div>
        <div class="p-2" *ngIf="MostrarTerminosCondiciones()">
            <mat-label class="lblblack" *ngIf="MostrarTerminosCondiciones()">Términos y condiciones</mat-label>
        </div>
        <div class="p-0 marginiconoterminos" *ngIf="MostrarTerminosCondiciones()">
            <a type="button" class="icnTable" target="_blank" [href]="this.form.get('rutaTerminosCondiciones').value" *ngIf="MostrarTerminosCondiciones()">
                <mat-icon>find_in_page</mat-icon>
            </a>
        </div>
    </div>
    <div [formGroup]="form" fxFlex="auto" fxLayout="row" class="row filtrosTable" autocomplete="off" style="margin-left: 0 !important;">
        <div class="col-12">
            <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
        </div>
    </div>
    <div class="mat-elevation-z8 p-0">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                <!-- annio Column -->
                <ng-container matColumnDef="annio">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Año</th>
                    <td mat-cell *matCellDef="let row"> {{row.annio}} </td>
                </ng-container>

                <!-- mes Column -->
                <ng-container matColumnDef="mes">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Mes</th>
                    <td mat-cell *matCellDef="let row"> {{row.mes}} </td>
                </ng-container>

                <!-- recaudo Column -->
                <ng-container matColumnDef="recaudo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Recaudo</th>
                    <td mat-cell *matCellDef="let row"> {{row.recaudo}} </td>
                </ng-container>

                <!-- fechaRecaudo Column -->
                <ng-container matColumnDef="fechaRecaudo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Fecha recaudo</th>
                    <td mat-cell *matCellDef="let row"> {{row.fechaRecaudo | fechapipe}} </td>
                </ng-container>

                <!-- producto Column -->
                <ng-container matColumnDef="producto">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Producto</th>
                    <td mat-cell *matCellDef="let row"> {{row.producto}} </td>
                </ng-container>

                <!-- valorCobro Column -->
                <ng-container matColumnDef="valorCobro">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Valor</th>
                    <td mat-cell *matCellDef="let row"> {{row.valorCobro | numeropipe}} </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No existen datos</td>
                </tr>
            </table>
        </div>
    </div>
</div>